/* eslint-disable*/
import {
  Box,
  Dialog,
  IconButton,
  Typography,
  Divider
} from '@material-ui/core';
import PerformancePullDown from 'components/atoms/button/PerformancePullDown';
import { currentchannel } from 'feactures/channel/channelSlice';
import {
  performanceModalOpen,
  performancereviewAmazonOtherReviewResult,
  performancereviewAmazonOwnReviewResult,
  performancereviewOtherDataLoading,
  performancereviewOwnDataLoading,
  performancereviewRakutenOtherReviewResult,
  performancereviewRakutenOwnReviewResult,
  performancereviewAmazonOtherItemData,
  performancereviewAmazonOwnItemData,
  performancereviewRakutenOtherItemData,
  performancereviewRakutenOwnItemData,
  performanceSeoLoading,
  performanceSeoSetting,
  performanceSeoData,
  resetKeyword,
  setPerformanceModalOpen
} from 'feactures/performancereview/performancereviewSlice';
import FreePlanUpgradeDialog from 'components/atoms/modal/FreePlanUpgradeDialog';
import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import SeoContent from './SeoContent';

const SeoResultDialog = ({ detailTitle }) => {
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const modalOpen = useSelector(performanceModalOpen);
  const index = modalOpen.index;
  const [openUpgradeDialog, setOpenUpgradeDialog] = useState(false);
  const setting = useSelector(performanceSeoSetting);
  const seodata = useSelector(performanceSeoData);
  const ownLoading = useSelector(performancereviewOwnDataLoading);
  const otherLoading = useSelector(performancereviewOtherDataLoading);
  const seoLoading = useSelector(performanceSeoLoading);
  const ownAmazonData = useSelector(performancereviewAmazonOwnItemData);
  const ownRakutenData = useSelector(performancereviewRakutenOwnItemData);
  const otherAmazonData = useSelector(performancereviewAmazonOtherItemData);
  const otherRakutenData = useSelector(performancereviewRakutenOtherItemData);
  const ownAmazonPerformanceDataList = useSelector(
    performancereviewAmazonOwnReviewResult
  );
  const otherAmazonPerformanceDataList = useSelector(
    performancereviewAmazonOtherReviewResult
  );
  const ownRakutenPerformanceDataList = useSelector(
    performancereviewRakutenOwnReviewResult
  );
  const otherRakutenPerformanceDataList = useSelector(
    performancereviewRakutenOtherReviewResult
  );
  const channel = useSelector(currentchannel);
  let ownItemData = [];
  let otherItemData = [];
  let ownPerformanceData = [];
  let otherPerformanceData = [];
  let ownRank = 0;
  let otherRank = 0;
  if (channel == 1) {
    ownItemData = ownAmazonData;
    otherItemData = otherAmazonData;
    ownPerformanceData = ownAmazonPerformanceDataList;
    otherPerformanceData = otherAmazonPerformanceDataList;
  } else if (channel == 2) {
    ownItemData = ownRakutenData;
    otherItemData = otherRakutenData;
    ownPerformanceData = ownRakutenPerformanceDataList;
    otherPerformanceData = otherRakutenPerformanceDataList;
  }

  const detailsIndex = modalOpen.detailsIndex;
  const ownDetails =
    ownPerformanceData[modalOpen.index]?.details?.[detailsIndex] || {};
  const otherDetails =
    otherPerformanceData[modalOpen.index]?.details?.[detailsIndex] || {};
  const ownResult = ownDetails.evaluationFlag;
  const otherResult = otherDetails?.evaluationFlag;
  const ownReason = ownDetails.reason;
  const otherReason = otherDetails.reason;

  ownRank =
    setting.seoType == 'organic'
      ? seodata.own.organicRank
      : seodata.own.sponsorRank;

  otherRank =
    setting.seoType == 'organic'
      ? seodata.other.organicRank
      : seodata.other.sponsorRank;

  const handleUpgradeDialogClose = () => {
    setOpenUpgradeDialog(false);
  };

  return (
    <>
      <Dialog
        open={modalOpen.open && index == modalOpen.index}
        onClose={(event) => {
          event.stopPropagation(); // 親要素のテーブルの開閉が起きないようイベントの伝播を停止
          dispatch(
            setPerformanceModalOpen({ index: 0, open: false, detailsIndex: 0 })
          ); // モーダルを閉じる
        }}
        onClick={(event) => {
          event.stopPropagation(); // 親要素のテーブルの開閉が起きないようイベントの伝播を停止
        }}
        PaperProps={{
          sx: { width: '90%', maxWidth: '1500px' }
        }}
      >
        <Box p={3}>
          <Box height="70%">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                color="rgba(113,140,198,1)"
                fontWeight="bold"
                fontSize="15px"
              >
                2.検索 ＞ {detailTitle}
              </Typography>
              <IconButton
                onClick={(event) => {
                  event.stopPropagation(); // 親要素のテーブルの開閉が起きないようイベントの伝播を停止
                  dispatch(resetKeyword());
                  dispatch(
                    setPerformanceModalOpen({
                      index: 0,
                      open: false,
                      detailsIndex: 0
                    })
                  ); // モーダルを閉じる
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <Box display="flex" alignItems="center" mt={2}>
              <Box>
                <PerformancePullDown
                  graphLoading={ownLoading || otherLoading || seoLoading}
                  page="search"
                />
              </Box>
            </Box>
            <Box my={1}>
              <Typography fontWeight={600}>
                掲載順位は登録した翌日から反映されます
              </Typography>
              <Typography>
                ※診断結果は登録された全てのキーワードをもとに判定しています
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between" gap="18px">
              {/* 自社グラフ */}
              <SeoContent
                title={detailTitle}
                compareType="own"
                rank={ownRank}
                result={ownResult}
                reason={ownReason}
                selectFlag={true}
                performanceLoading={ownLoading}
              />
              <Divider orientation="vertical" flexItem />
              {/* 競合グラフ */}
              <SeoContent
                title={detailTitle}
                compareType="other"
                rank={otherRank}
                result={otherResult}
                reason={otherReason}
                selectFlag={!otherItemData || !otherItemData?.itemName == ''}
                performanceLoading={otherLoading}
              />
            </Box>
          </Box>
        </Box>
      </Dialog>
      {/* 無料プランアップグレードダイアログ */}
      <FreePlanUpgradeDialog
        open={openUpgradeDialog}
        onClose={handleUpgradeDialogClose}
        word={'キーワード'}
        page={'seoResultDialog'}
      />
    </>
  );
};

export default SeoResultDialog;
